(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-v2"]) return;
  try {
    
  if (!customElements.get('sticky-header')) {
    class StickyHeader extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.header = document.querySelector('.section-header');
        this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
        this.headerBounds = {};

        this.setHeaderHeight();

        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-sticky');
        };

        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
      }

      setHeaderHeight() {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }

      disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
      }

      createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        });

        observer.observe(this.header);
      }

      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
      }

      hide() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.closeMenuDisclosure();
        this.closeSearchModal();
      }

      reveal() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      }

      reset() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }

      closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
        this.disclosures.forEach(disclosure => disclosure.close());
      }

      closeSearchModal() {
        this.searchModal = this.searchModal || this.header.querySelector('details-modal');
        this.searchModal.close(false);
      }
    }

    customElements.define('sticky-header', StickyHeader);
  }

  // Ask an Expert click-toggle with hover support
  document.querySelectorAll('.ask-expert').forEach(function(widget) {
    var trigger = widget.querySelector('.ask-expert__trigger');
    var suppressHover = false;
    var hoverTimeout = null;

    widget.addEventListener('mouseenter', function() {
      clearTimeout(hoverTimeout);
      if (!suppressHover) widget.classList.add('is-hovered');
    });
    widget.addEventListener('mouseleave', function() {
      hoverTimeout = setTimeout(function() {
        widget.classList.remove('is-hovered');
        suppressHover = false;
      }, 200);
    });

    trigger.addEventListener('click', function(e) {
      e.stopPropagation();
      if (widget.classList.contains('is-open')) {
        widget.classList.remove('is-open');
        widget.classList.remove('is-hovered');
        suppressHover = true;
        trigger.setAttribute('aria-expanded', 'false');
      } else {
        widget.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });
  document.addEventListener('click', function(e) {
    document.querySelectorAll('.ask-expert.is-open').forEach(function(widget) {
      if (!widget.contains(e.target)) {
        widget.classList.remove('is-open');
        widget.querySelector('.ask-expert__trigger').setAttribute('aria-expanded', 'false');
      }
    });
  });

  // Ask an Expert live open/closed status (US Eastern Time)
  // Hours: Mon-Fri 8am-9pm, Sun 11am-9pm (Sat closed)
  (function() {
    if (!document.querySelector('[data-open-hours]')) return;
    // day index: 0=Sun ... 6=Sat. Open minute inclusive, close minute exclusive. null = closed all day.
    var HOURS = [
      { open: 11 * 60, close: 21 * 60 }, // Sun
      { open:  8 * 60, close: 21 * 60 }, // Mon
      { open:  8 * 60, close: 21 * 60 }, // Tue
      { open:  8 * 60, close: 21 * 60 }, // Wed
      { open:  8 * 60, close: 21 * 60 }, // Thu
      { open:  8 * 60, close: 21 * 60 }, // Fri
      null                                // Sat (closed)
    ];
    var DAY_NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    function readET() {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York',
        weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false
      }).formatToParts(new Date());
      var out = {};
      parts.forEach(function(p) {
        if (p.type === 'weekday') out.day = p.value;
        else if (p.type === 'hour') out.hour = parseInt(p.value, 10) % 24;
        else if (p.type === 'minute') out.minute = parseInt(p.value, 10);
      });
      out.dayIdx = DAY_NAMES.indexOf(out.day);
      return out;
    }
    function isOpen(t) {
      var h = HOURS[t.dayIdx];
      if (!h) return false;
      var mins = t.hour * 60 + t.minute;
      return mins >= h.open && mins < h.close;
    }
    function fmtTime(mins) {
      var h = Math.floor(mins / 60);
      var m = mins % 60;
      var suffix = h >= 12 ? 'pm' : 'am';
      var h12 = h % 12; if (h12 === 0) h12 = 12;
      return h12 + (m ? ':' + (m < 10 ? '0' : '') + m : '') + suffix;
    }
    function nextOpenLabel(t) {
      var todayMins = t.hour * 60 + t.minute;
      var today = HOURS[t.dayIdx];
      // If today hasn't opened yet, opens today
      if (today && todayMins < today.open) {
        return 'Opens today ' + fmtTime(today.open);
      }
      // Otherwise scan up to 7 days ahead for the next open day
      for (var i = 1; i <= 7; i++) {
        var idx = (t.dayIdx + i) % 7;
        var h = HOURS[idx];
        if (!h) continue;
        var label = (i === 1) ? 'tomorrow' : DAY_NAMES[idx];
        return 'Opens ' + label + ' ' + fmtTime(h.open);
      }
      return '';
    }
    function apply() {
      var t;
      try { t = readET(); } catch (e) { return; }
      var open = isOpen(t);
      document.querySelectorAll('[data-open-hours]').forEach(function(el) {
        var txt = el.querySelector('.ask-expert__status-text');
        var parent = el.parentElement;
        var nextOpenEl = parent ? parent.querySelector('[data-next-open]') : null;
        var emailCta = parent ? parent.querySelector('[data-email-cta]') : null;
        if (open) {
          el.removeAttribute('data-closed');
          if (txt) txt.textContent = "We're Open";
          if (nextOpenEl) {
            nextOpenEl.textContent = '';
            nextOpenEl.removeAttribute('data-visible');
          }
          if (emailCta) emailCta.removeAttribute('data-visible');
        } else {
          el.setAttribute('data-closed', '');
          if (txt) txt.textContent = 'Closed';
          if (nextOpenEl) {
            nextOpenEl.textContent = nextOpenLabel(t);
            nextOpenEl.setAttribute('data-visible', '');
          }
          if (emailCta) emailCta.setAttribute('data-visible', '');
        }
      });
    }
    apply();
    setInterval(apply, 60000);

    // Email CTA: open mailto without triggering the panel toggle
    document.querySelectorAll('[data-email-cta]').forEach(function(cta) {
      function openMail(e) {
        e.preventDefault();
        e.stopPropagation();
        var addr = cta.getAttribute('data-email');
        if (addr) window.location.href = 'mailto:' + addr;
      }
      cta.addEventListener('click', openMail);
      cta.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') openMail(e);
      });
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Ask an Expert click-toggle with hover support
  document.querySelectorAll('.ask-expert').forEach(function(widget) {
    var trigger = widget.querySelector('.ask-expert__trigger');
    var suppressHover = false;
    var hoverTimeout = null;

    widget.addEventListener('mouseenter', function() {
      clearTimeout(hoverTimeout);
      if (!suppressHover) widget.classList.add('is-hovered');
    });
    widget.addEventListener('mouseleave', function() {
      hoverTimeout = setTimeout(function() {
        widget.classList.remove('is-hovered');
        suppressHover = false;
      }, 200);
    });

    trigger.addEventListener('click', function(e) {
      e.stopPropagation();
      if (widget.classList.contains('is-open')) {
        widget.classList.remove('is-open');
        widget.classList.remove('is-hovered');
        suppressHover = true;
        trigger.setAttribute('aria-expanded', 'false');
      } else {
        widget.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });
  document.addEventListener('click', function(e) {
    document.querySelectorAll('.ask-expert.is-open').forEach(function(widget) {
      if (!widget.contains(e.target)) {
        widget.classList.remove('is-open');
        widget.querySelector('.ask-expert__trigger').setAttribute('aria-expanded', 'false');
      }
    });
  });


  } catch(e) { console.error(e); }
})();
})();
